import { Language } from './types'

export const LANGUAGES = ['en', 'jp'] as const
export const DEFAULT_LANGUAGE: Language = 'en'
export const POSTS_PER_PAGE = 8 // for all list pages
export const GDPR_COOKIE_NAME = 'gatsby-gdpr-google-analytics'
